import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tag, Wallet, ArrowRight } from "lucide-react";
import { API, inr } from "../lib/api";
import Seo from "../components/Seo";

export default function Drops() {
  const [items, setItems] = useState([]);
  useEffect(() => { API.get("/drops").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-[#FAF6F1] min-h-[70vh]" data-testid="drops-page">
      <Seo title="Club Drops | New Discoveries, Special Access — Suvikka" description="Suvikka Club Drops — new discoveries, special member access and limited launches. Member prices and wallet rewards on selected products." canonicalPath="/drops" />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#6A1B29]">Club Drops</p>
        <div className="flex items-end justify-between gap-4">
          <h1 className="font-display text-3xl sm:text-5xl font-semibold text-stone-900 mt-2">Exclusive Finds. Just for You.</h1>
          <Link to="/club" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-[#6A1B29]">Join Club <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <p className="text-stone-500 mt-3">Limited-time collections, handpicked for our Club members.</p>
        {items.length === 0 ? (
          <p className="mt-16 text-center text-stone-500 bg-white border border-stone-200 rounded-2xl p-12" data-testid="drops-empty">No Club Drops live right now. New drops are added regularly — join the Club to get notified 💗</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-10" data-testid="drops-grid">
            {items.map((p) => {
              const off = p.mrp > p.selling_price ? Math.round((1 - p.selling_price / p.mrp) * 100) : 0;
              return (
                <Link key={p.id} to={`/product/${p.slug || p.id}`} data-testid={`drop-card-${p.sku}`} className="group bg-white border border-stone-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all">
                  <div className="relative aspect-[4/5] overflow-hidden bg-stone-100">
                    {p.images?.[0] && <img src={p.images[0]} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                    <span className="absolute top-3 left-3 bg-[#6A1B29] text-white text-[10px] font-bold px-2.5 py-1 rounded-full">🔥 Club Drop</span>
                    {off > 0 && <span className="absolute top-3 right-3 bg-stone-900 text-white text-[10px] font-bold px-2 py-1 rounded">{off}% OFF</span>}
                  </div>
                  <div className="p-3 sm:p-4">
                    <p className="text-[10px] font-semibold tracking-[0.2em] uppercase text-[#6A1B29]">{p.category}</p>
                    <h3 className="text-sm sm:text-base font-medium text-stone-900 mt-1 line-clamp-1">{p.title}</h3>
                    <div className="flex items-baseline gap-2 mt-1.5">
                      <span className="text-base font-semibold text-stone-900">{inr(p.selling_price)}</span>
                      {p.mrp > p.selling_price && <span className="text-xs text-stone-400 line-through">{inr(p.mrp)}</span>}
                    </div>
                    {p.club_price != null && <p className="mt-1.5 inline-flex items-center gap-1 text-xs font-bold text-[#6A1B29] bg-[#FFF0F4] px-2 py-1 rounded"><Tag className="w-3 h-3" /> CLUB {inr(p.club_price)}</p>}
                    {p.wallet_reward > 0 && <span className="ml-1.5 inline-flex items-center gap-1 text-xs font-semibold text-amber-700 bg-amber-50 px-2 py-1 rounded"><Wallet className="w-3 h-3" /> {inr(p.wallet_reward)}</span>}
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
